import * as React from 'react'
import { MarkerClusterer } from '@react-google-maps/api'
import { IPoint } from '../../../../interfaces/types.ts'
import { useSnapshot } from 'valtio'
import { dataState } from '../../../../store/dataState.ts'
import { historyState } from '../../../../store/historyState.ts'
import { controlState } from '../../../../store/controlState.ts'
import { NumberMarker } from './NumberMarker.tsx'

interface Props {

}
// randy@newportave.com|woofwoof@gibitechnologies.com
const clusterOptions = {
    minimumClusterSize: 2,
    maxZoom: 17
};

export const ClusterMarker: React.FC<Props> = () => {
    const locations = (useSnapshot(historyState) as typeof historyState).locations
    const markerWindowStart = (useSnapshot(historyState) as typeof historyState).markerWindowStart
    const pets = (useSnapshot(dataState) as typeof dataState).pets
    const map = (useSnapshot(historyState) as typeof historyState).map
    const isMobile = useSnapshot(controlState).isOnMobileDevice

    // On mobile, only show 10 markers centred around the active carousel card.
    // On desktop, show all loaded markers.
    const visibleLocations = isMobile
        ? locations.slice(markerWindowStart, markerWindowStart + 10)
        : locations

    // Fit bounds when the visible set changes — desktop only.
    // On mobile, the carousel's panTo controls the map center.
    React.useEffect(() => {
        if (isMobile) return
        if (!map || !visibleLocations?.length) return
        const bounds = new google.maps.LatLngBounds()
        let hasValid = false
        visibleLocations.forEach((point: IPoint) => {
            if (point.properties.status) {
                bounds.extend({
                    lat: point.properties.latitude,
                    lng: point.properties.longitude,
                })
                hasValid = true
            }
        })
        if (hasValid) {
            map.fitBounds(bounds)
        }
    }, [visibleLocations, map])

    if (!visibleLocations?.length) return null

    // Build marker elements
    const markers = visibleLocations.map((point: IPoint, i: number) => {
        const latLng = new google.maps.LatLng({
            lat: point.properties.latitude,
            lng: point.properties.longitude,
        })
        if (!point.properties.status) return null
        const pet = pets.find(pet => pet._id === point.properties.itemId)
        const globalIndex = markerWindowStart + i
        return <NumberMarker
            key={`${point.properties.deviceId}-${globalIndex}`}
            point={point}
            color={pet?.iconColor || ''}
            num={globalIndex + 1}
            position={latLng}
        />
    }).filter(n => n)

    // Mobile: no clustering, just render markers directly
    if (isMobile) {
        return <>{markers}</>
    }

    // Desktop: use MarkerClusterer
    return (
        <MarkerClusterer options={clusterOptions}>
            {(clusterer) =>
                <div>{
                    visibleLocations.map((point: IPoint, i: number) => {
                        const latLng = new google.maps.LatLng({
                            lat: point.properties.latitude,
                            lng: point.properties.longitude,
                        })
                        if (!point.properties.status) return null
                        const pet = pets.find(pet => pet._id === point.properties.itemId)
                        const globalIndex = markerWindowStart + i
                        return <NumberMarker
                            key={`${point.properties.deviceId}-${globalIndex}`}
                            point={point}
                            color={pet?.iconColor || ''}
                            num={globalIndex + 1}
                            position={latLng}
                            clusterer={clusterer}
                        />
                    }).filter(n => n)
                }</div>
            }
        </MarkerClusterer>
    )
}
